import { PatientStatus } from "@domain/patient/patient";
import { Gender } from "@domain/patient/gender";
import { useCallback } from "react";
import { SVGComponent } from "@typings/svg-component";
import ManIcon from "@assets/icons/man.svg";
import ManIconHover from "@assets/icons/man-hover.svg";
import WomanIcon from "@assets/icons/woman.svg";
import WomanIconHover from "@assets/icons/woman-hover.svg";
import OtherGenderIcon from "@assets/icons/no-gender.svg";
import OtherGenderIconHover from "@assets/icons/no-gender-hover.svg";

type PatientGenderDetails = { gender?: Gender; status: PatientStatus };

interface UseGenderIconHook {
	getGenderIcon: (genderDetails: PatientGenderDetails, isHovering?: boolean) => SVGComponent;
}

export const useGenderIcon = (): UseGenderIconHook => {
	const getGenderIcon = useCallback(({ gender, status }: PatientGenderDetails, isHovering = false): SVGComponent => {
		if (status === PatientStatus.Pending) return isHovering ? OtherGenderIconHover : OtherGenderIcon;
		if (gender === Gender.Man) return isHovering ? ManIconHover : ManIcon;
		if (gender === Gender.Woman) return isHovering ? WomanIconHover : WomanIcon;
		return OtherGenderIcon;
	}, []);

	return { getGenderIcon };
};
